import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Generated class for the CcpDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[ccp]' // Attribute selector
})
export class CcpDirective {

  constructor() {
    console.log('Hello CcpDirective Directive');
  }
  // @HostListener( 'window:keydown', [ '$event' ] )
   @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
     
    e.preventDefault();
   
   }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
      e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
      e.preventDefault();
    }
  

}



// WEBPACK FOOTER //
// ./src/directives/ccp/ccp.ts